export default {
  name: "SellerFilterItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};